import { render, staticRenderFns } from "./AuditConsistentlyFailingElements.vue?vue&type=template&id=571c4484&"
import script from "./AuditConsistentlyFailingElements.vue?vue&type=script&lang=ts&"
export * from "./AuditConsistentlyFailingElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports